<div class="table-container">
    <nz-table
        #table
        [nzTitle]="tableTitle()"
        [nzFrontPagination]="isFrontPagination()"
        [nzShowSizeChanger]="true"
        [nzData]="tableData()"
        [nzTotal]="tablePagination()?.total || 0"
        [nzPageSize]="tablePagination()?.pageSize || 10"
        [nzPageIndex]="tablePagination()?.pageIndex || 1"
        [nzShowTotal]="totalTemplate"
        (nzQueryParams)="onQueryParamsChange($event)"
    >
        <thead>
            <tr>
                @for (column of tableColumns(); track $index) {
                    @if(column.header.type == ColumnType.CHECKBOX) {
                        <th 
                            [nzWidth]="!isMobile() ? '64px' : null"
                            [nzShowCheckbox]="column"
                            [(nzChecked)]="allChecked"
                            (nzCheckedChange)="onCheckAllChange($event)"
                        ></th>
                    }@else {
                        <th
                            nzEllipsis
                            [nzShowSort]="column.header.isSortable"
                            [nzShowFilter]="false"
                            [nzSortFn]="true"
                            [nzColumnKey]="column.header.key.toString()"
                            [nzWidth]="column.header.width && !isMobile() ? `${column.header.width}px` : null"
                        >{{column.header.label | translate}}</th>
                    }
                }
            </tr>
        </thead>
        <tbody>
            @for(row of table.data; track $index) {
                <tr>
                    @for (column of tableColumns(); track $index) {
                        @switch (column.header.type) {
                            @case(ColumnType.CHECKBOX) {
                                <td
                                    nzShowCheckbox
                                    [nzChecked]="allChecked() || (column.checkValue ? column.checkValue(row).checkedRow! : false)" 
                                    [attr.data-cell]="(column.header.mobileHeader || 'GLOBAL.SELECT-ROW') | translate"
                                    [nzDisabled]="column?.checkValue ? (column?.checkValue(row)?.disabledRow ? true : false) : false" 
                                    (nzCheckedChange)="onCheckRowChange(row, $event)"
                                >
                                </td>
                            }
                            @case(ColumnType.LINK) {
                                <td [attr.data-cell]="(column.header.label || column.header.mobileHeader || '') | translate">
                                    <a [routerLink]="column.linkValue ? column.linkValue(row).path : ''">
                                        {{column.linkValue ? (column.linkValue(row).label | translate) : ''}}
                                    </a>
                                </td>
                            }
                            @case(ColumnType.DATE) {
                                <td [attr.data-cell]="(column.header.label || column.header.mobileHeader || '') | translate">
                                    {{column.cellValue ? column.cellValue(row) : '' | date: 'dd.MM.yyyy'}}
                                </td>
                            }
                            @case (ColumnType.TEMPLATE) {
                                <td [attr.data-cell]="(column.header.label || column.header.mobileHeader || '') | translate">
                                    <ng-container *ngTemplateOutlet="column.template!; context: { row: row,  genericEvent: genericEvent }" />
                                </td>
                            }
                            @case (ColumnType.EXPAND) {
                                <td [nzExpand]="expandSet.has(row)" (nzExpandChange)="onExpandChange(row, $event)" style="display:grid; place-items:center;"></td>
                            }
                            @default {
                                <td [attr.data-cell]="(column.header.label || column.header.mobileHeader || '') | translate">
                                    {{column.cellValue ? column.cellValue(row) : ''}}
                                </td>
                            } 
                        }
                    }
                </tr>
                @if (hasExpandColumn()) {
                    <tr [nzExpand]="expandSet.has(row)">
                        <ng-container *ngTemplateOutlet="getExpandColumn()!.template!; context: { row: row }">
                        </ng-container>
                    </tr>
                }
            }
        </tbody>   
    </nz-table>
</div>
<ng-template #totalTemplate let-total>Ukupno {{total}}</ng-template>
<ng-template #totalTemplate let-total>{{'GLOBAL.TOTAL' | translate}} {{total}}</ng-template>